/** Whether compensation terms apply / are required for a staff role. */

export function isCompensationOptionalForRole(role: string | undefined | null): boolean {
  return String(role ?? '').toLowerCase() === 'banker';
}

export function isCompensationRequiredForRole(role: string | undefined | null): boolean {
  return !isCompensationOptionalForRole(role);
}

export type CompensationDisplayUser = {
  compensationType?: string | null;
  commission?: number | null;
  fixedFee?: number | null;
};

/** True when the profile has explicit compensation terms (not merely commission: 0). */
export function hasCompensationTerms(user: CompensationDisplayUser): boolean {
  const type = String(user.compensationType ?? '').toLowerCase();
  if (type === 'percent') {
    const pct = Number(user.commission);
    return Number.isFinite(pct) && pct > 0;
  }
  if (type === 'fixed') {
    const fee = Number(user.fixedFee);
    return Number.isFinite(fee) && fee > 0;
  }
  return false;
}

/** Badge label for directory rows; null when terms are unset. */
export function formatCompensationBadge(user: CompensationDisplayUser): string | null {
  if (!hasCompensationTerms(user)) return null;
  const type = String(user.compensationType ?? '').toLowerCase();
  if (type === 'fixed') {
    const fee = Number(user.fixedFee);
    return Number.isFinite(fee) ? `$${fee}` : null;
  }
  const pct = Number(user.commission);
  return Number.isFinite(pct) ? `${pct}%` : null;
}
